import { useState } from 'react'
import { useMutation } from '@tanstack/react-query'
import { registerMonthlyCourseApi, unregisterMonthlyCourseApi } from '@!/Api/monthlyCourse'

export const useMonthlyCourse = () => {
  const [apiError, setApiError] = useState({ error: null, errorInfo: null })

  const registerMonthlyCourseMutation = useMutation({
    mutationFn: (params) => registerMonthlyCourseApi(params),
    onError: (error) => {
      if (error.data?.error) {
        const errorInfo = error.data?.ErrInfo ? error.data.ErrInfo : null
        setApiError({ error: error.data.error, errorInfo: errorInfo })
      } else {
        setApiError({ error: 'etc_error' })
      }
    },
  })

  const unregisterMonthlyCourseMutation = useMutation({
    mutationFn: (orderId) => unregisterMonthlyCourseApi({ order_id: orderId }),
    onError: (error) => {
      if (error.data?.error) {
        const errorInfo = error.data?.ErrInfo ?? null
        setApiError({ error: error.data.error, errorInfo })
      } else {
        setApiError({ error: 'etc_error' })
      }
    },
  })

  return {
    registerMonthlyCourseMutation,
    unregisterMonthlyCourseMutation,
    apiError,
  }
}
